import React from 'react';
import { colors, fonts } from '../tokens';
import { EnPowerWordmarkInline } from '../../EnPowerLogo';

/**
 * PageFooter – einheitlicher Footer für alle Inhaltsseiten des Dach-PV-Angebots.
 */
export const PageFooter = ({ page }) => (
  <div className="page-footer">
    <EnPowerWordmarkInline
      enColor={colors.navy}
      powerColor={colors.orange}
      fontFamily={fonts.body}
      fontSize="8px"
      fontWeight={700}
      letterSpacing="0.04em"
    />
    <span style={{ fontFamily: fonts.body, fontSize: '8px', color: '#CBD5E1', letterSpacing: '0.02em' }}>Photovoltaik &bull; Dachverpachtung &bull; Energieprojekte</span>
    <span style={{ fontFamily: fonts.display, fontSize: '8.5px', fontWeight: 600, color: '#CBD5E1' }}>{page}</span>
  </div>
);
